import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { brandLockup, brandMark } from '@bookora/design';
/**
 * Below this height (px) the lockup's lettering stops resolving. See the
 * header. Exported so a caller sizing from a layout constant can ask rather
 * than guess.
 */
export const LOGO_LOCKUP_MIN_HEIGHT = 24;
const ROLE_FILL = {
    ink: 'var(--bk-brand-ink)',
    coral: 'var(--bk-brand-coral)',
};
const ARTWORK = {
    mark: brandMark,
    lockup: brandLockup,
};
/** `"minX minY width height"` → the artwork's width ÷ height. */
function aspectRatio(viewBox) {
    const [, , width, height] = viewBox.split(/\s+/).map(Number);
    return width && height ? width / height : 1;
}
export function Logo({ variant = 'lockup', size = 28, className, title, }) {
    // See "THE SMALL-SIZE GUARD" above: a lockup asked for below the height its
    // lettering survives is a request for the mark.
    const cut = variant === 'lockup' && size < LOGO_LOCKUP_MIN_HEIGHT ? 'mark' : variant;
    const artwork = ARTWORK[cut];
    const width = Math.round(size * aspectRatio(artwork.viewBox) * 100) / 100;
    const labelled = Boolean(title);
    return (_jsxs("svg", { className: className, viewBox: artwork.viewBox, width: width, height: size, 
        // The artwork is already tight around its ink (see `brand.ts`), so the
        // default `xMidYMid meet` is a no-op — stated anyway so a caller who
        // stretches the box with CSS gets letterboxing, not a distorted mark.
        preserveAspectRatio: "xMidYMid meet", role: labelled ? 'img' : undefined, "aria-label": title, "aria-hidden": labelled ? undefined : true, focusable: "false", style: { display: 'block', flex: 'none' }, children: [labelled ? _jsx("title", { children: title }) : null, artwork.paths.map((path) => (_jsx("path", { d: path.d, fill: ROLE_FILL[path.role] }, path.d)))] }));
}
//# sourceMappingURL=logo.js.map